module.exports = __webpack_public_path__ + "img/d_web.88b3f200.jpg";